// extracted by mini-css-extract-plugin
export default {"colorText":"Mda-z","colorTextLabel":"Nda-z","colorTextValue":"Oda-z","swatches":"Pda-z","collapseLink":"Qda-z","isCollapsed":"Rda-z","dropdown":"Sda-z","disabled":"Tda-z"};